import moment from 'moment';

export default (date) => {
  const momentObject = moment.utc(date);
  if (!momentObject.isValid()) return null;
  return momentObject.format('MM/DD/YYYY');
};
